import { Col } from "react-bootstrap"
import { JCaption, JCard, JCardBody, JHeader, JPaginacao, JTable, JTBody, JTHead } from "../../components/Components"
import { useContext, useEffect, useState } from "react"
import { AuthContext } from "../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import rotaService from "../../services/RotaService";

export const IndexRota = () => {
    const [dados, setDados] = useState<any[]>([]);
    const [meta, setMeta] = useState<any>(null);
    const [links, setLinks] = useState<any>(null);
    const [showSpinner, setShowSpinner] = useState(true);
    const [search, setSearch] = useState('');
    const authContext = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/rota/create');
        }
    }

    const searchFilter = async (page: string | null = null) => {

        setShowSpinner(true);

        await rotaService.getAllPaginate(search, page).then(response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);

        }).catch(err => {
            if (err.response.status === 403) {
                authContext?.setShowError(true)
                authContext?.setShowMessageError(err.response.data.message);
                navigate('/');
            }
            setShowSpinner(false);
        });

    }

    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }
    return (<>
        <div className="row d-flex justify-content-between align-items-start g-2">
            <Col md>
                <JCard >
                    <JHeader
                        urlCreate="/rota/create"
                        search={search}
                        setSearch={setSearch}
                        showSpinner={showSpinner}
                        permissionCreate={authContext?.userLogado.is_staff || authContext?.userLogado.is_superuser}
                        permissionSearch={authContext?.userLogado.is_staff || authContext?.userLogado.is_superuser}
                    />

                    <JCardBody>
                        <JCaption title="Lista de Rotas">
                            <JPaginacao
                                links={links ?? {}}
                                meta={meta ?? {}}
                                handlePageChange={handlePageChange} />
                        </JCaption>
                        <JTable >
                            <JTHead>
                                <tr>
                                    <th>DESCRIÇÃO</th>
                                    <th>UF INICIO</th>
                                    <th>UF FIM</th>
                                </tr>
                            </JTHead>
                            <JTBody>
                                {dados?.map((data) => (
                                    <tr key={data.id}>
                                        <td>
                                            {authContext?.userLogado.is_superuser === 1 && (
                                                <Link title="Clique no nome para editar e ou remover"
                                                    className="text-primary" to={`/rota/${data.id}`}
                                                    style={{ textDecoration: 'none' }}>
                                                    {data.descricao}
                                                </Link>
                                            )}
                                        </td>
                                        <td>{data.ufini}</td>
                                        <td>{data.uffim}</td>
                                    </tr>
                                ))}
                            </JTBody>
                        </JTable>
                    </JCardBody>
                </JCard>
            </Col>
        </div>
    </>)
}